"use client"

import { useState } from "react"
import Modal from "./Modal"
import "../styles/Hero.css"
import { saveInquiry } from "../api/inquiries"
import heroImage from "../assets/images/heroimage1.png"
import highpoint from "../assets/images/high-point.webp"

export default function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    consent: false,
  })
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    // For phone field: only allow digits and max 10 chars
    if (name === "phone") {
      if (/^\d{0,10}$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }))
      }
      return
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required"
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can only contain letters and spaces"
    }

    // Phone validation
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required"
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit number"
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid Email address"
    }

    // Consent checkbox validation
    if (!formData.consent) {
      newErrors.consent = "Please accept the consent to proceed"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) return

    const now = new Date()
    const offsetMs = 5.5 * 60 * 60 * 1000
    const istTime = new Date(now.getTime() + offsetMs)
    const inquiry_datetime = istTime.toISOString().replace("T", " ").split(".")[0]

    const payload = {
      inquiry_datetime,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
    }

    setLoading(true)
    try {
      await saveInquiry(payload)
      alert("Thank you for your interest! We will contact you soon.")
      setFormData({ name: "", phone: "", email: "", consent: false })
      setErrors({})
    } catch (err) {
      console.error(err)
      alert("Failed to submit inquiry. Please try again later.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <section className="hero">
        <img src={heroImage} alt="Ashtech Presidential Towers" className="hero-bg" />
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="hero-left">
            <h1 className="hero-title">Ashtech Presidential Towers</h1>
            <span className="location-badge gradient">At Greater Noida, Uttar Pradesh</span>

            <div className="features">
              <div className="feature-item">
                <img src={highpoint} alt="Prime Location" className="feature-icon" />
                <span>Prime Location</span>
              </div>
              <div className="feature-item">
                <img src={highpoint} alt="Private Elevator" className="feature-icon" />
                <span>Private Elevator Access</span>
              </div>
            </div>

            <div className="highlight-box">
              <div className="highlight-items">EOI Window Now Open</div>
              <div className="highlight-items">Avail Exclusive Launch Offers</div>
            </div>

            <h2 className="apartment-title">Ultra-Luxury 3, 4 BHK Apartments</h2>

            <div className="price-box">
              <span className="start">Starts At :</span>
              <span className="price gradient">₹ 2.5 Cr*</span>
            </div>

            <div className="hero-buttons">
              <button className="hero-button1" onClick={() => setIsModalOpen(true)}>
                BOOK A SITE VISIT !
              </button>
              <button className="hero-buttons2" onClick={() => setIsModalOpen(true)}>
                QUICK ENQUIRY !
              </button>
            </div>
          </div>

          <div className="hero-right">
            <div className="form-card">
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="error-text">{errors.name}</p>}

                <input
                  type="tel"
                  name="phone"
                  placeholder="Enter Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className="error-text">{errors.phone}</p>}

                <input
                  type="email"
                  name="email"
                  placeholder="Enter Email ID"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="error-text">{errors.email}</p>}

                <div className="consent-checkbox">
                  <input
                    type="checkbox"
                    id="consent"
                    name="consent"
                    checked={formData.consent}
                    onChange={handleChange}
                  />
                  <label htmlFor="consent">
                    I authorize company representatives to Call, SMS, Email or WhatsApp me about its
                    products and offers. This consent overrides any registration for DNC/NDNC.
                  </label>
                </div>
                {errors.consent && <p className="error-text">{errors.consent}</p>}

                <button type="submit" className="form-submit-btn" disabled={loading}>
                  {loading ? "Submitting..." : "SUBMIT"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}

// "use client"

// import { useState } from "react"
// import Modal from "./Modal"
// import "../styles/Hero.css"
// import { saveInquiry } from "../api/inquiries"
// // import heroImage from '../assets/images/heroimage.png'
// import heroImage from "../assets/images/heroimage1.png"
// import highpoint from "../assets/images/high-point.webp"

// export default function Hero() {
//   const [isModalOpen, setIsModalOpen] = useState(false)
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     consent: false,
//   })
//   const [loading, setLoading] = useState(false)

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }))
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     const now = new Date()
//     const offsetMs = 5.5 * 60 * 60 * 1000 // IST = UTC + 5 hours 30 mins
//     const istTime = new Date(now.getTime() + offsetMs)
//     const inquiry_datetime = istTime.toISOString().replace("T", " ").split(".")[0]
//     // const inquiry_datetime = new Date().toISOString().replace("T", " ").split(".")[0]
//     const payload = {
//       inquiry_datetime,
//       name: formData.name,
//       email: formData.email,
//       phone: formData.phone,
//     }

//     setLoading(true)
//     try {
//       await saveInquiry(payload)
//       alert("Thank you for your interest! We will contact you soon.")
//       setFormData({ name: "", phone: "", email: "", consent: false })
//     } catch (err) {
//       console.error(err)
//       alert("Failed to submit inquiry. Please try again later.")
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <>
//       <section className="hero">
//         <img src={`${heroImage}`} alt="Ashtech Presidential Towers" className="hero-bg"/>

//         <div className="hero-overlay"></div>

//         <div className="hero-content">
//           <div className="hero-left">
//             <h1 className="hero-title">Ashtech Presidential Towers</h1>
//             <span className="location-badge gradient">At Greater Noida, Uttar Pradesh</span>

//             <div className="features">
//               <div className="feature-item">
//                 <img src={`${highpoint}`} alt="Prime Location" className="feature-icon" />
//                 <span>Prime Location</span>
//               </div>
//               <div className="feature-item">
//                 <img src={`${highpoint}`} alt="Private Elevator" className="feature-icon" />
//                 <span>Private Elevator Access</span>
//               </div>
//             </div>

//             <div className="highlight-box">
//               <div className="highlight-items">EOI Window Now Open</div>
//               <div className="highlight-items">Avail Exclusive Launch Offers</div>
//             </div>

//             <h2 className="apartment-title">Ultra-Luxury 3, 4 BHK Apartments</h2>

//             <div className="price-box">
//               <span className="start">Starts At :</span>
//               <span className="price gradient">₹ 2.5 Cr*</span>
//             </div>

//             <div className="hero-buttons">
//               <button className="hero-button1" onClick={() => setIsModalOpen(true)}>
//                 BOOK A SITE VISIT !
//               </button>
//               <button className="hero-buttons2" onClick={() => setIsModalOpen(true)}>
//                 QUICK ENQUIRY !
//               </button>
//             </div>
//           </div>

//           <div className="hero-right">
//             <div className="form-card">
//               <form onSubmit={handleSubmit}>

//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Enter Name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                 />
//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Enter Phone Number"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   required
//                   pattern="\d{10}" 
//                   title="Please enter a 10-digit mobile number"
//                 />
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Enter Email ID"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//                 <div className="consent-checkbox">
//                   <input
//                     type="checkbox"
//                     id="consent"
//                     name="consent"
//                     checked={formData.consent}
//                     onChange={handleChange}
//                     required
//                   />
//                   <label htmlFor="consent">
//                     I authorize company representatives to Call, SMS, Email or WhatsApp me about its products and
//                     offers. This consent overrides any registration for DNC/NDNC.
//                   </label>
//                 </div>
//                 <button type="submit" className="form-submit-btn" disabled={loading}>
//                   {loading ? "Submitting..." : "SUBMIT"}
//                 </button>

//               </form>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
//     </>
//   )
// }
